var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSofa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 13,
    viewBox: "0 0 26 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4994 10.5H0.746094L0.746094 12.5H2.49748V11.7505H23.4991V12.5H25.2505V10.5H23.4994Z",
    fill: "#1F342F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7458 1.25H7.74638H18.2497H18.25C18.9795 1.25 19.679 1.53982 20.1947 2.05557L20.7251 1.52523L20.1947 2.05557C20.7105 2.57129 21.0003 3.27098 21.0003 4.00029V8.5022H4.99609L4.9961 4.00029L4.99609 3.99969C4.99552 3.2703 5.2851 2.57065 5.80091 2.05483C6.31673 1.53902 7.0164 1.24944 7.7458 1.25Z",
    stroke: "#1F342F",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.746094 5.74902H2.49748V9.24931H0.746094V5.74902Z",
    fill: "#1F342F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5039 5.74902H25.2553V9.24931H23.5039V5.74902Z",
    fill: "#1F342F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa);
export default __webpack_public_path__ + "static/media/sofa.1d1ab7a8dc148207bfb183663d425f4a.svg";
export { ForwardRef as ReactComponent };